import styled from 'styled-components';

export const SubscriptionCardContainer = styled.div`
  margin: 10px 5px 10px 0px;
  width: 100%;
  border-radius: 16px;
  background: ${(props) => props.theme.neutralLighter};
  box-shadow: inset 0 6px 0 0 ${({ theme }: {theme: any}) => theme.themePrimary};
  padding: 32px;

  .ms-DetailsRow {
    &:hover .mgt-person {
      background: ${(props) => props.theme.neutralLighter};
    }
  }

  .ms-MessageBar {
    margin-bottom: 1rem;
    border-radius: 1rem;
    background: ${(props) => props.theme.neutralLight};
    color: ${(props) => props.theme.black};
  }

  .bitbuttonsmall {
    display: flex;
    width: fit-content;
    align-items: center;
    padding: 8px 16px;
    gap: 6px;
    border-radius: 8px;
    border: none;
    font: 700 0.9rem/1.1rem 'Roboto', sans-serif;
    background: ${({ theme }: {theme: any}) => theme.themePrimary};
    color: #fff;
    cursor: pointer;

    &:hover {
      filter: brightness(1.3);
      transition: all 0.3s ease;
    }
  }
`;

export const SubscriptionCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  padding-bottom: 24px;
  margin-bottom: 24px;

  .planTitle {
    display: grid;
    grid-template-columns: 48px auto;
    gap: 4px 16px;

    img {
      grid-row: 1/3;
      width: 48px;
      height: 48px;
      object-fit: contain;
    }

    h1 {
      font: 700 1.2rem/1.2em 'Roboto', sans-serif;
      color: ${({ theme }: {theme: any}) => theme.black};
      display: flex;
      gap: 16px;
      align-items: center;
      align-self: baseline;

      > div {
        margin-bottom: 4px;
      }
    }

    h2 {
      color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
      font: 400 0.9rem/0.9rem 'Roboto', sans-serif;
    }
  }

  .planInfo {
    display: flex;
    gap: 24px;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;

      h2 {
        font: 700 0.9rem/1.1rem 'Roboto', sans-serif;
      }

      p {
        color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
        font: 400 0.9rem/0.9rem 'Roboto', sans-serif;
      }

      &.status {
        display: flex;
        align-items: center;
      }
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background-color: ${({ theme }: {theme: any}) => theme.black};
  }
`;

export const SubscriptionCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 16px;

  section {
    display: flex;
    flex-direction: column;
    gap: 8px;

    h3 {
      font: 300 1.2rem/1.5rem 'Roboto', sans-serif;
      color: ${({ theme }: {theme: any}) => theme.neutralPrimary};
    }

    > p {
      color: ${({ theme }: {theme: any}) => theme.themeSecondary};
      font: 400 0.9rem/0.9rem 'Roboto', sans-serif;
    }

    .subscriptionsContainer {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      gap: 24px;

      .subscriptionItem {
        display: grid;
        column-gap: 8px;

        i {
          grid-column: 1/2;
          color: ${({ theme }: {theme: any}) => theme.themePrimary};
          align-self: center;
        }

        h4 {
          align-self: center;
        }

        p {
          color: ${({ theme }: {theme: any}) => theme.neutralTertiary};
        }

        h4,
        p {
          grid-column: 2/3;
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
`;

export const SubscriptionPanelFooter = styled.div`
  display: flex;
  gap: 0.5rem;
`;
